module.exports = __webpack_public_path__ + "img/ventilation_unit.d604138f.svg";